/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditTicketTypeBodyBody,
    GetTicketTypesParams,
    ReorderItemsBodyBody,
    RequestStatusResponseResponse,
    TicketTypeCreateSuccessResponseResponse,
    TicketTypeSuccessResponseResponse,
    TicketTypesSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Add new ticket type
 */
export const addTicketType = (
    addEditTicketTypeBodyBody: AddEditTicketTypeBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<TicketTypeCreateSuccessResponseResponse>({
        url: `/tickettypes`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditTicketTypeBodyBody,
        signal,
    });
};

export const getAddTicketTypeMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addTicketType>>,
        TError,
        { data: AddEditTicketTypeBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addTicketType>>,
    TError,
    { data: AddEditTicketTypeBodyBody },
    TContext
> => {
    const mutationKey = ['addTicketType'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addTicketType>>,
        { data: AddEditTicketTypeBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return addTicketType(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddTicketTypeMutationResult = NonNullable<Awaited<ReturnType<typeof addTicketType>>>;
export type AddTicketTypeMutationBody = AddEditTicketTypeBodyBody;
export type AddTicketTypeMutationError = APIErrorResponseResponse;

/**
 * @summary Add new ticket type
 */
export const useAddTicketType = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addTicketType>>,
        TError,
        { data: AddEditTicketTypeBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addTicketType>>,
    TError,
    { data: AddEditTicketTypeBodyBody },
    TContext
> => {
    const mutationOptions = getAddTicketTypeMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get ticket types matching the filters
 */
export const getTicketTypes = (params?: GetTicketTypesParams, signal?: AbortSignal) => {
    return customInstance<TicketTypesSuccessResponseResponse>({
        url: `/tickettypes`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetTicketTypesQueryKey = (params?: GetTicketTypesParams) => {
    return [`/tickettypes`, ...(params ? [params] : [])] as const;
};

export const getGetTicketTypesQueryOptions = <
    TData = Awaited<ReturnType<typeof getTicketTypes>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetTicketTypesParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketTypes>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTicketTypesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTicketTypes>>> = ({ signal }) =>
        getTicketTypes(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTicketTypes>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTicketTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getTicketTypes>>>;
export type GetTicketTypesQueryError = APIErrorResponseResponse;

/**
 * @summary Get ticket types matching the filters
 */

export function useGetTicketTypes<
    TData = Awaited<ReturnType<typeof getTicketTypes>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetTicketTypesParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketTypes>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTicketTypesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get ticket type by id
 */
export const getTicketType = (id: number, signal?: AbortSignal) => {
    return customInstance<TicketTypeSuccessResponseResponse>({
        url: `/tickettypes/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetTicketTypeQueryKey = (id?: number) => {
    return [`/tickettypes/${id}`] as const;
};

export const getGetTicketTypeQueryOptions = <
    TData = Awaited<ReturnType<typeof getTicketType>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketType>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTicketTypeQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTicketType>>> = ({ signal }) =>
        getTicketType(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTicketType>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTicketTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getTicketType>>>;
export type GetTicketTypeQueryError = APIErrorResponseResponse;

/**
 * @summary Get ticket type by id
 */

export function useGetTicketType<
    TData = Awaited<ReturnType<typeof getTicketType>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketType>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTicketTypeQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit ticket type
 */
export const editTicketType = (
    id: number,
    addEditTicketTypeBodyBody: AddEditTicketTypeBodyBody,
) => {
    return customInstance<TicketTypeSuccessResponseResponse>({
        url: `/tickettypes/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditTicketTypeBodyBody,
    });
};

export const getEditTicketTypeMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTicketType>>,
        TError,
        { id: number; data: AddEditTicketTypeBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editTicketType>>,
    TError,
    { id: number; data: AddEditTicketTypeBodyBody },
    TContext
> => {
    const mutationKey = ['editTicketType'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editTicketType>>,
        { id: number; data: AddEditTicketTypeBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editTicketType(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditTicketTypeMutationResult = NonNullable<Awaited<ReturnType<typeof editTicketType>>>;
export type EditTicketTypeMutationBody = AddEditTicketTypeBodyBody;
export type EditTicketTypeMutationError = APIErrorResponseResponse;

/**
 * @summary Edit ticket type
 */
export const useEditTicketType = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTicketType>>,
        TError,
        { id: number; data: AddEditTicketTypeBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editTicketType>>,
    TError,
    { id: number; data: AddEditTicketTypeBodyBody },
    TContext
> => {
    const mutationOptions = getEditTicketTypeMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete ticket type by id
 */
export const deleteTicketType = (id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/tickettypes/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteTicketTypeMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTicketType>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteTicketType>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['deleteTicketType'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteTicketType>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return deleteTicketType(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTicketTypeMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteTicketType>>
>;

export type DeleteTicketTypeMutationError = APIErrorResponseResponse;

/**
 * @summary Delete ticket type by id
 */
export const useDeleteTicketType = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTicketType>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteTicketType>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getDeleteTicketTypeMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Reorder ticket types
 */
export const reorderTicketTypes = (
    reorderItemsBodyBody: ReorderItemsBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/tickettypes/reorder`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reorderItemsBodyBody,
        signal,
    });
};

export const getReorderTicketTypesMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof reorderTicketTypes>>,
        TError,
        { data: ReorderItemsBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof reorderTicketTypes>>,
    TError,
    { data: ReorderItemsBodyBody },
    TContext
> => {
    const mutationKey = ['reorderTicketTypes'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof reorderTicketTypes>>,
        { data: ReorderItemsBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return reorderTicketTypes(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ReorderTicketTypesMutationResult = NonNullable<
    Awaited<ReturnType<typeof reorderTicketTypes>>
>;
export type ReorderTicketTypesMutationBody = ReorderItemsBodyBody;
export type ReorderTicketTypesMutationError = APIErrorResponseResponse;

/**
 * @summary Reorder ticket types
 */
export const useReorderTicketTypes = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof reorderTicketTypes>>,
        TError,
        { data: ReorderItemsBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof reorderTicketTypes>>,
    TError,
    { data: ReorderItemsBodyBody },
    TContext
> => {
    const mutationOptions = getReorderTicketTypesMutationOptions(options);

    return useMutation(mutationOptions);
};
